import React, { useState } from "react";
import QRCode from "qrcode.react";
import { toast } from "react-toastify";
import {
  enable2fa,
  confirm2fa,
  disable2fa,
  fetchRecoveryCodes,
  regenerateRecoveryCodes,
} from "../Auth/_redux/authCrud";

export default function TwoFactorSetup({ enabled, onChange }) {
  const [step, setStep] = useState("idle"); // idle | qr | confirm
  const [qrUri, setQrUri] = useState(null);
  const [secret, setSecret] = useState(null);
  const [code, setCode] = useState("");
  const [recoveryCodes, setRecoveryCodes] = useState(null);
  const [loading, setLoading] = useState(false);

  const startEnable = () => {
    setLoading(true);
    enable2fa()
      .then(({ data }) => {
        setQrUri(data.qr_code_uri);
        setSecret(data.secret);
        setStep("confirm");
      })
      .catch(() => toast.error("Gagal memulai aktivasi 2FA."))
      .finally(() => setLoading(false));
  };

  const submitConfirm = (e) => {
    e.preventDefault();
    setLoading(true);
    confirm2fa(code)
      .then(({ data }) => {
        setRecoveryCodes(data.recovery_codes);
        setStep("idle");
        setCode("");
        onChange(true);
        toast.success("2FA berhasil diaktifkan.");
      })
      .catch(() => toast.error("Kode salah, coba lagi."))
      .finally(() => setLoading(false));
  };

  const handleDisable = () => {
    setLoading(true);
    disable2fa()
      .then(() => {
        onChange(false);
        setRecoveryCodes(null);
        toast.success("2FA dinonaktifkan.");
      })
      .catch(() => toast.error("Gagal menonaktifkan 2FA."))
      .finally(() => setLoading(false));
  };

  const handleViewRecoveryCodes = () => {
    setLoading(true);
    fetchRecoveryCodes()
      .then(({ data }) => setRecoveryCodes(data.recovery_codes))
      .catch(() => toast.error("Gagal mengambil kode pemulihan."))
      .finally(() => setLoading(false));
  };

  const handleRegenerate = () => {
    setLoading(true);
    regenerateRecoveryCodes()
      .then(({ data }) => setRecoveryCodes(data.recovery_codes))
      .catch(() => toast.error("Gagal membuat ulang kode pemulihan."))
      .finally(() => setLoading(false));
  };

  if (enabled) {
    return (
      <div>
        <p className="text-success font-weight-bold">2FA aktif di akun Anda.</p>
        <button className="btn btn-light-danger mr-2" onClick={handleDisable} disabled={loading}>
          Nonaktifkan 2FA
        </button>
        <button className="btn btn-light-primary" onClick={handleViewRecoveryCodes} disabled={loading}>
          Lihat kode pemulihan
        </button>
        {recoveryCodes && (
          <div className="mt-4">
            <div className="bg-light p-4 rounded font-mono">
              {recoveryCodes.map((c) => (
                <div key={c}>{c}</div>
              ))}
            </div>
            <button className="btn btn-sm btn-light-warning mt-2" onClick={handleRegenerate} disabled={loading}>
              Buat ulang kode pemulihan
            </button>
          </div>
        )}
      </div>
    );
  }

  if (step === "confirm") {
    return (
      <form onSubmit={submitConfirm}>
        <p>Pindai kode QR ini dengan aplikasi autentikator Anda:</p>
        <QRCode value={qrUri} size={200} />
        <p className="mt-3">
          Atau masukkan kunci ini secara manual: <code>{secret}</code>
        </p>
        <div className="form-group mt-3">
          <label>Masukkan kode 6 digit dari aplikasi Anda</label>
          <input
            type="text"
            className="form-control"
            maxLength={6}
            value={code}
            onChange={(e) => setCode(e.target.value)}
            required
          />
        </div>
        <button type="submit" className="btn btn-primary" disabled={loading || code.length < 6}>
          Konfirmasi
        </button>
      </form>
    );
  }

  return (
    <div>
      <p>Akun Anda belum menggunakan 2FA.</p>
      <button className="btn btn-primary" onClick={startEnable} disabled={loading}>
        Aktifkan 2FA
      </button>
    </div>
  );
}
